/* eslint-disable @typescript-eslint/no-explicit-any */
import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
export type MakeEmpty<
  T extends { [key: string]: unknown },
  K extends keyof T,
> = { [_ in K]?: never };
export type Incremental<T> =
  | T
  | {
      [P in keyof T]?: P extends " $fragmentName" | "__typename" ? T[P] : never;
    };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  DateTime: { input: any; output: any };
};

export type AdminAlertParticipantEvent = {
  __typename?: "AdminAlertParticipantEvent";
  message: Scalars["String"]["output"];
  target: Scalars["String"]["output"];
  timestamp: Scalars["Float"]["output"];
};

export type AdminHoldParticipantEvent = {
  __typename?: "AdminHoldParticipantEvent";
  timestamp: Scalars["Float"]["output"];
  userId: Scalars["String"]["output"];
};

export type AdminJoinApproveEvent = {
  __typename?: "AdminJoinApproveEvent";
  approvedBy: Scalars["String"]["output"];
  timestamp: Scalars["Float"]["output"];
  userId: Scalars["String"]["output"];
};

export type AdminJoinRequestEvent = {
  __typename?: "AdminJoinRequestEvent";
  fullName: Scalars["String"]["output"];
  timestamp: Scalars["Float"]["output"];
  userId: Scalars["String"]["output"];
};

export type AdminKickParticipantEvent = {
  __typename?: "AdminKickParticipantEvent";
  result?: Maybe<Scalars["String"]["output"]>;
  timestamp: Scalars["Float"]["output"];
  userId: Scalars["String"]["output"];
};

export type AdminListUpdate = {
  __typename?: "AdminListUpdate";
  timestamp: Scalars["Float"]["output"];
};

export type AdminReapproveParticipantEvent = {
  __typename?: "AdminReapproveParticipantEvent";
  timestamp: Scalars["Float"]["output"];
  userId: Scalars["String"]["output"];
};

export enum AdminStatus {
  Offline = "OFFLINE",
  Online = "ONLINE",
}

export type AdminStatusUpdate = {
  __typename?: "AdminStatusUpdate";
  status: Scalars["String"]["output"];
  timestamp: Scalars["Float"]["output"];
};

export type ChatGroup = {
  __typename?: "ChatGroup";
  avatarUrl: Scalars["String"]["output"];
  dateOfCreate: Scalars["DateTime"]["output"];
  id: Scalars["ID"]["output"];
  name: Scalars["String"]["output"];
  unreadCount: Scalars["Int"]["output"];
  usersIds: Array<Scalars["String"]["output"]>;
};

export type ChatMessageOutput = {
  __typename?: "ChatMessageOutput";
  groupId: Scalars["String"]["output"];
  roomName: Scalars["String"]["output"];
  senderId: Scalars["String"]["output"];
  senderName: Scalars["String"]["output"];
  text: Scalars["String"]["output"];
  timestamp: Scalars["DateTime"]["output"];
};

export type ChatMutations = {
  __typename?: "ChatMutations";
  clearChat: Scalars["Boolean"]["output"];
  clearEverything: Scalars["Boolean"]["output"];
  createGroup: ChatGroup;
  sendMessage: Scalars["Boolean"]["output"];
};

export type ChatMutationsCreateGroupArgs = {
  avatarUrl: Scalars["String"]["input"];
  id: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  usersId: Scalars["String"]["input"];
};

export type ChatMutationsSendMessageArgs = {
  groupId: Scalars["String"]["input"];
  text: Scalars["String"]["input"];
};

export type ChatQueries = {
  __typename?: "ChatQueries";
  chatHistory: Array<ChatMessageOutput>;
  getGroupById: ChatGroup;
  getListChatsGroup: Array<ChatGroup>;
};

export type ChatQueriesChatHistoryArgs = {
  groupId: Scalars["String"]["input"];
  last?: Scalars["Float"]["input"];
};

export type ChatQueriesGetGroupByIdArgs = {
  groupId: Scalars["String"]["input"];
};

export type CreateRoomInput = {
  /** زمان خاموشی (ثانیه) تا بستن اتاق وقتی خالی است؛ پیش‌فرض 300 */
  emptyTimeout?: InputMaybe<Scalars["Int"]["input"]>;
  /** بیشینهٔ شرکت‌کنندگان (پیش‌فرض 50) */
  maxParticipants?: InputMaybe<Scalars["Int"]["input"]>;
  /** نام یکتا برای اتاق */
  name?: Scalars["String"]["input"];
};

export type JoinRoomOutput = {
  __typename?: "JoinRoomOutput";
  livekitToken: Scalars["String"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  roomData: RoomEntity;
  success: Scalars["Boolean"]["output"];
  userData: User;
};

export type LineInfoResponse = {
  __typename?: "LineInfoResponse";
  DocStatus: Scalars["String"]["output"];
  count: Scalars["Int"]["output"];
  found_user?: Maybe<UpcomingUserOutput>;
  index: Scalars["Int"]["output"];
};

export type Mutation = {
  __typename?: "Mutation";
  chat: ChatMutations;
  room: RoomMutations;
};

export type ParticipantInfoOutput = {
  __typename?: "ParticipantInfoOutput";
  audioLevel: Scalars["Int"]["output"];
  identity: Scalars["String"]["output"];
  joinedAt: Scalars["DateTime"]["output"];
  name?: Maybe<Scalars["String"]["output"]>;
  /** آیا ناشر رسانه است */
  publisher: Scalars["Boolean"]["output"];
};

export type PatientDocumentOutput = {
  __typename?: "PatientDocumentOutput";
  date: Scalars["String"]["output"];
  desc: Scalars["String"]["output"];
  filename: Scalars["String"]["output"];
  gv_docs_data_id: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  location: Scalars["String"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  pid: Scalars["String"]["output"];
  sender_id: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
  vid: Scalars["String"]["output"];
};

export type Query = {
  __typename?: "Query";
  chat: ChatQueries;
  health: Scalars["String"]["output"];
  room: RoomQueries;
  user: UserQueries;
};

export type RemoveUpcomingUserEvent = {
  __typename?: "RemoveUpcomingUserEvent";
  timestamp: Scalars["Float"]["output"];
  userId: Scalars["String"]["output"];
};

export type RoomEntity = {
  __typename?: "RoomEntity";
  adminId: Scalars["ID"]["output"];
  adminStatus: AdminStatus;
  name: Scalars["String"]["output"];
  nameMembers: Array<Scalars["String"]["output"]>;
  numMembers: Scalars["Float"]["output"];
  startTime: Scalars["String"]["output"];
  title: Scalars["String"]["output"];
};

export type RoomInfoOutput = {
  __typename?: "RoomInfoOutput";
  createdAt: Scalars["DateTime"]["output"];
  name: Scalars["String"]["output"];
  numParticipants: Scalars["Int"]["output"];
};

export type RoomMutations = {
  __typename?: "RoomMutations";
  admitUser: UpcomingUserOutput;
  alertTheParticipant: Scalars["Boolean"]["output"];
  approveUpcomingUser: Scalars["Boolean"]["output"];
  askToJion: Scalars["Boolean"]["output"];
  createLivekitRoom: RoomInfoOutput;
  deleteLivekitRoom: Scalars["Boolean"]["output"];
  holdParticipant: Scalars["Boolean"]["output"];
  join: JoinRoomOutput;
  kickParticipant: Scalars["Boolean"]["output"];
  muteTrack: Scalars["Boolean"]["output"];
  removeUpcomingUser: Scalars["Boolean"]["output"];
  setUserStartTime: Scalars["Boolean"]["output"];
  updateUpcomingVisitTimes: Array<UpcomingUserOutput>;
};

export type RoomMutationsAdmitUserArgs = {
  target: Scalars["String"]["input"];
};

export type RoomMutationsAlertTheParticipantArgs = {
  message: Scalars["String"]["input"];
  target: Scalars["String"]["input"];
};

export type RoomMutationsApproveUpcomingUserArgs = {
  userId: Scalars["String"]["input"];
};

export type RoomMutationsCreateLivekitRoomArgs = {
  input: CreateRoomInput;
};

export type RoomMutationsHoldParticipantArgs = {
  identity: Scalars["String"]["input"];
  isTakeBack?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type RoomMutationsJoinArgs = {
  bioArcRoomId: Scalars["String"]["input"];
};

export type RoomMutationsKickParticipantArgs = {
  identity: Scalars["String"]["input"];
  info?: InputMaybe<Info>;
};

export type RoomMutationsMuteTrackArgs = {
  identity: Scalars["String"]["input"];
  muted?: Scalars["Boolean"]["input"];
  roomName: Scalars["String"]["input"];
  trackSid: Scalars["String"]["input"];
};

export type RoomMutationsRemoveUpcomingUserArgs = {
  userId: Scalars["String"]["input"];
};

export type RoomMutationsSetUserStartTimeArgs = {
  startTime: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type RoomMutationsUpdateUpcomingVisitTimesArgs = {
  updates: Array<VisitTimeUpdateInput>;
};

export type RoomQueries = {
  __typename?: "RoomQueries";
  getLatestUpcomingUsers: Array<UpcomingUserOutput>;
  getPatientDocument: Array<PatientDocumentOutput>;
  getUserDurationMinutes?: Maybe<Scalars["Float"]["output"]>;
  getUserStartTime?: Maybe<Scalars["String"]["output"]>;
  lineinfo: LineInfoResponse;
  livekitParticipants: Array<ParticipantInfoOutput>;
  livekitRooms: Array<RoomInfoOutput>;
  upcomingUsers: Array<UpcomingUserOutput>;
  waitingUsers: Array<UpcomingUserOutput>;
};

export type RoomQueriesGetPatientDocumentArgs = {
  vid: Scalars["String"]["input"];
};

export type RoomQueriesGetUserDurationMinutesArgs = {
  roomName: Scalars["String"]["input"];
  userId: Scalars["String"]["input"];
};

export type RoomQueriesGetUserStartTimeArgs = {
  userId: Scalars["String"]["input"];
};

export type RoomQueriesLivekitParticipantsArgs = {
  roomName: Scalars["String"]["input"];
};

export type RoomQueriesUpcomingUsersArgs = {
  roomName: Scalars["String"]["input"];
};

export type RoomQueriesWaitingUsersArgs = {
  roomName: Scalars["String"]["input"];
};

export type RoomSubscriptionPayload = {
  __typename?: "RoomSubscriptionPayload";
  adminAlertParticipant?: Maybe<AdminAlertParticipantEvent>;
  adminHoldParticipant?: Maybe<AdminHoldParticipantEvent>;
  adminJoinApprove?: Maybe<AdminJoinApproveEvent>;
  adminJoinRequest?: Maybe<AdminJoinRequestEvent>;
  adminKickParticipant?: Maybe<AdminKickParticipantEvent>;
  adminListUpdate?: Maybe<AdminListUpdate>;
  adminReapproveParticipant?: Maybe<AdminReapproveParticipantEvent>;
  adminStatusUpdate?: Maybe<AdminStatusUpdate>;
  eventType: Scalars["String"]["output"];
  removeUpcomingUser?: Maybe<RemoveUpcomingUserEvent>;
  roomName: Scalars["String"]["output"];
};

export type Subscription = {
  __typename?: "Subscription";
  adminEvents: RoomSubscriptionPayload;
  roomEvents: RoomSubscriptionPayload;
  userEvents: RoomSubscriptionPayload;
};

export type SubscriptionAdminEventsArgs = {
  roomName: Scalars["String"]["input"];
};

export type SubscriptionRoomEventsArgs = {
  roomName: Scalars["String"]["input"];
};

export type SubscriptionUserEventsArgs = {
  userId: Scalars["String"]["input"];
};

export type UpcomingUserOutput = {
  __typename?: "UpcomingUserOutput";
  approved: Scalars["Boolean"]["output"];
  avatarUrl: Scalars["String"]["output"];
  duration_minutes: Scalars["Float"]["output"];
  end_local: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  gv_id: Scalars["String"]["output"];
  hash: Scalars["String"]["output"];
  id: Scalars["String"]["output"];
  isDone: Scalars["Boolean"]["output"];
  isPaused: Scalars["Boolean"]["output"];
  message?: Maybe<Scalars["String"]["output"]>;
  mobile: Scalars["String"]["output"];
  national_code: Scalars["String"]["output"];
  pid: Scalars["String"]["output"];
  role: Scalars["String"]["output"];
  start_local: Scalars["String"]["output"];
  success: Scalars["Boolean"]["output"];
  visitTime: Scalars["String"]["output"];
  visit_guest: Scalars["String"]["output"];
  wantsToJoin: Scalars["Boolean"]["output"];
};

export type User = {
  __typename?: "User";
  approved: Scalars["Boolean"]["output"];
  avatarUrl?: Maybe<Scalars["String"]["output"]>;
  cid: Scalars["String"]["output"];
  fullName: Scalars["String"]["output"];
  gv_id: Scalars["String"]["output"];
  hash: Scalars["String"]["output"];
  id: Scalars["ID"]["output"];
  isDone: Scalars["Boolean"]["output"];
  isPaused: Scalars["Boolean"]["output"];
  role: Scalars["String"]["output"];
  room_name: Scalars["String"]["output"];
  subtitle: Scalars["String"]["output"];
  visitTime: Scalars["String"]["output"];
  visit_guest: Scalars["String"]["output"];
  wantsToJoin: Scalars["Boolean"]["output"];
  wid: Scalars["String"]["output"];
};

export type UserQueries = {
  __typename?: "UserQueries";
  currentUserInfo: User;
};

export type VisitTimeUpdateInput = {
  /** زمان پایان ویزیت  */
  end_time?: Scalars["String"]["input"];
  /** شناسهٔ کاربر */
  id?: Scalars["ID"]["input"];
  /** زمان شروع ویزیت  */
  start_time?: Scalars["String"]["input"];
  /** زمان ویزیت (بر حسب دقیقه یا میلی‌ثانیه) */
  visitTime?: Scalars["String"]["input"];
};

export type Info = {
  drug?: InputMaybe<Scalars["Boolean"]["input"]>;
  pic?: InputMaybe<Scalars["Boolean"]["input"]>;
  rest?: InputMaybe<Scalars["Boolean"]["input"]>;
  test?: InputMaybe<Scalars["Boolean"]["input"]>;
};

export type CurrentUserInfoQueryVariables = Exact<{ [key: string]: never }>;

export type CurrentUserInfoQuery = {
  __typename?: "Query";
  user: {
    __typename?: "UserQueries";
    currentUserInfo: {
      __typename?: "User";
      id: string;
      fullName: string;
      avatarUrl?: string | null;
      approved: boolean;
      visitTime: string;
      wantsToJoin: boolean;
      role: string;
      hash: string;
      gv_id: string;
      isPaused: boolean;
      isDone: boolean;
    };
  };
};

export type SendMessageMutationVariables = Exact<{
  groupId: Scalars["String"]["input"];
  text: Scalars["String"]["input"];
}>;

export type SendMessageMutation = {
  __typename?: "Mutation";
  chat: { __typename?: "ChatMutations"; sendMessage: boolean };
};

export type CreateGroupMutationVariables = Exact<{
  id: Scalars["String"]["input"];
  usersId: Scalars["String"]["input"];
  name: Scalars["String"]["input"];
  avatarUrl: Scalars["String"]["input"];
}>;

export type CreateGroupMutation = {
  __typename?: "Mutation";
  chat: {
    __typename?: "ChatMutations";
    createGroup: {
      __typename?: "ChatGroup";
      id: string;
      name: string;
      usersIds: Array<string>;
      avatarUrl: string;
    };
  };
};

export type ClearChatMutationVariables = Exact<{ [key: string]: never }>;

export type ClearChatMutation = {
  __typename?: "Mutation";
  chat: { __typename?: "ChatMutations"; clearChat: boolean };
};

export type ChatHistoryQueryVariables = Exact<{
  groupId: Scalars["String"]["input"];
}>;

export type ChatHistoryQuery = {
  __typename?: "Query";
  chat: {
    __typename?: "ChatQueries";
    chatHistory: Array<{
      __typename?: "ChatMessageOutput";
      text: string;
      roomName: string;
      senderId: string;
      senderName: string;
      groupId: string;
      timestamp: any;
    }>;
  };
};

export type GetGroupByIdQueryVariables = Exact<{
  groupId: Scalars["String"]["input"];
}>;

export type GetGroupByIdQuery = {
  __typename?: "Query";
  chat: {
    __typename?: "ChatQueries";
    getGroupById: {
      __typename?: "ChatGroup";
      id: string;
      name: string;
      dateOfCreate: any;
      usersIds: Array<string>;
      unreadCount: number;
      avatarUrl: string;
    };
  };
};

export type GetListChatsGroupQueryVariables = Exact<{ [key: string]: never }>;

export type GetListChatsGroupQuery = {
  __typename?: "Query";
  chat: {
    __typename?: "ChatQueries";
    getListChatsGroup: Array<{
      __typename?: "ChatGroup";
      id: string;
      name: string;
      dateOfCreate: any;
      usersIds: Array<string>;
      unreadCount: number;
      avatarUrl: string;
    }>;
  };
};

export type ClearEverythingMutationVariables = Exact<{ [key: string]: never }>;

export type ClearEverythingMutation = {
  __typename?: "Mutation";
  chat: { __typename?: "ChatMutations"; clearEverything: boolean };
};

export type JoinLivekitMutationVariables = Exact<{
  bioArcRoomId: Scalars["String"]["input"];
}>;

export type JoinLivekitMutation = {
  __typename?: "Mutation";
  room: {
    __typename?: "RoomMutations";
    join: {
      __typename?: "JoinRoomOutput";
      success: boolean;
      livekitToken: string;
      message?: string | null;
      userData: {
        __typename?: "User";
        avatarUrl?: string | null;
        fullName: string;
        id: string;
        subtitle: string;
        role: string;
      };
      roomData: {
        __typename?: "RoomEntity";
        adminId: string;
        name: string;
        startTime: string;
        title: string;
        numMembers: number;
        nameMembers: Array<string>;
        adminStatus: AdminStatus;
      };
    };
  };
};

export type DeleteLivekitRoomMutationVariables = Exact<{
  [key: string]: never;
}>;

export type DeleteLivekitRoomMutation = {
  __typename?: "Mutation";
  room: { __typename?: "RoomMutations"; deleteLivekitRoom: boolean };
};

export type KickMutationVariables = Exact<{
  identity: Scalars["String"]["input"];
  info?: InputMaybe<Info>;
}>;

export type KickMutation = {
  __typename?: "Mutation";
  room: { __typename?: "RoomMutations"; kickParticipant: boolean };
};

export type MuteTrackMutationVariables = Exact<{
  roomName: Scalars["String"]["input"];
  identity: Scalars["String"]["input"];
  trackSid: Scalars["String"]["input"];
  muted: Scalars["Boolean"]["input"];
}>;

export type MuteTrackMutation = {
  __typename?: "Mutation";
  room: { __typename?: "RoomMutations"; muteTrack: boolean };
};

export type DeleteRoomMutationVariables = Exact<{ [key: string]: never }>;

export type DeleteRoomMutation = {
  __typename?: "Mutation";
  room: { __typename?: "RoomMutations"; deleteLivekitRoom: boolean };
};

export type GetUpcomingUsersQueryVariables = Exact<{
  roomName: Scalars["String"]["input"];
}>;

export type GetUpcomingUsersQuery = {
  __typename?: "Query";
  room: {
    __typename?: "RoomQueries";
    upcomingUsers: Array<{
      __typename?: "UpcomingUserOutput";
      id: string;
      fullName: string;
      avatarUrl: string;
      approved: boolean;
      visitTime: string;
      wantsToJoin: boolean;
      role: string;
      hash: string;
      gv_id: string;
      start_local: string;
      end_local: string;
      visit_guest: string;
      isPaused: boolean;
      isDone: boolean;
      duration_minutes: number;
    }>;
  };
};

export type GetLatestUpcomingUsersQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetLatestUpcomingUsersQuery = {
  __typename?: "Query";
  room: {
    __typename?: "RoomQueries";
    getLatestUpcomingUsers: Array<{
      __typename?: "UpcomingUserOutput";
      id: string;
      fullName: string;
      avatarUrl: string;
      approved: boolean;
      visitTime: string;
      wantsToJoin: boolean;
      role: string;
      hash: string;
      gv_id: string;
      start_local: string;
      end_local: string;
      visit_guest: string;
      isPaused: boolean;
      isDone: boolean;
      duration_minutes: number;
    }>;
  };
};

export type GetWaitingUsersQueryVariables = Exact<{
  roomName: Scalars["String"]["input"];
}>;

export type GetWaitingUsersQuery = {
  __typename?: "Query";
  room: {
    __typename?: "RoomQueries";
    waitingUsers: Array<{
      __typename?: "UpcomingUserOutput";
      id: string;
      fullName: string;
      avatarUrl: string;
      approved: boolean;
      visitTime: string;
      wantsToJoin: boolean;
      role: string;
      hash: string;
      gv_id: string;
      start_local: string;
      end_local: string;
      visit_guest: string;
      isPaused: boolean;
      isDone: boolean;
      duration_minutes: number;
    }>;
  };
};

export type GetRoomLineInfoQueryVariables = Exact<{ [key: string]: never }>;

export type GetRoomLineInfoQuery = {
  __typename?: "Query";
  room: {
    __typename?: "RoomQueries";
    lineinfo: {
      __typename?: "LineInfoResponse";
      count: number;
      index: number;
      DocStatus: string;
      found_user?: {
        __typename?: "UpcomingUserOutput";
        id: string;
        fullName: string;
        avatarUrl: string;
        visitTime: string;
        approved: boolean;
        wantsToJoin: boolean;
      } | null;
    };
  };
};

export type GetPatientDocumentQueryVariables = Exact<{
  vid: Scalars["String"]["input"];
}>;

export type GetPatientDocumentQuery = {
  __typename?: "Query";
  room: {
    __typename?: "RoomQueries";
    getPatientDocument: Array<{
      __typename?: "PatientDocumentOutput";
      id: string;
      pid: string;
      vid: string;
      filename: string;
      location: string;
      gv_docs_data_id: string;
      sender_id: string;
      desc: string;
      date: string;
    }>;
  };
};

export type ApproveUpcomingUserMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type ApproveUpcomingUserMutation = {
  __typename?: "Mutation";
  room: { __typename?: "RoomMutations"; approveUpcomingUser: boolean };
};

export type AskToJionMutationVariables = Exact<{ [key: string]: never }>;

export type AskToJionMutation = {
  __typename?: "Mutation";
  room: { __typename?: "RoomMutations"; askToJion: boolean };
};

export type AlertTheParticipantMutationVariables = Exact<{
  target: Scalars["String"]["input"];
  message: Scalars["String"]["input"];
}>;

export type AlertTheParticipantMutation = {
  __typename?: "Mutation";
  room: { __typename?: "RoomMutations"; alertTheParticipant: boolean };
};

export type RemoveUpcomingUserMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type RemoveUpcomingUserMutation = {
  __typename?: "Mutation";
  room: { __typename?: "RoomMutations"; removeUpcomingUser: boolean };
};

export type HoldParticipantMutationVariables = Exact<{
  identity: Scalars["String"]["input"];
  isTakeBack?: InputMaybe<Scalars["Boolean"]["input"]>;
}>;

export type HoldParticipantMutation = {
  __typename?: "Mutation";
  room: { __typename?: "RoomMutations"; holdParticipant: boolean };
};

export type UpdateUpcomingVisitTimesMutationVariables = Exact<{
  updates: Array<VisitTimeUpdateInput> | VisitTimeUpdateInput;
}>;

export type UpdateUpcomingVisitTimesMutation = {
  __typename?: "Mutation";
  room: {
    __typename?: "RoomMutations";
    updateUpcomingVisitTimes: Array<{
      __typename?: "UpcomingUserOutput";
      id: string;
      fullName: string;
      visitTime: string;
      approved: boolean;
      wantsToJoin: boolean;
      role: string;
      visit_guest: string;
      avatarUrl: string;
    }>;
  };
};

export type AdmitUserMutationVariables = Exact<{
  target: Scalars["String"]["input"];
}>;

export type AdmitUserMutation = {
  __typename?: "Mutation";
  room: {
    __typename?: "RoomMutations";
    admitUser: {
      __typename?: "UpcomingUserOutput";
      id: string;
      fullName: string;
      avatarUrl: string;
      approved: boolean;
      visitTime: string;
      wantsToJoin: boolean;
      role: string;
      hash: string;
      gv_id: string;
      start_local: string;
      end_local: string;
      visit_guest: string;
      isPaused: boolean;
      isDone: boolean;
      duration_minutes: number;
    };
  };
};

export type RoomEventsSubscriptionVariables = Exact<{
  roomName: Scalars["String"]["input"];
}>;

export type RoomEventsSubscription = {
  __typename?: "Subscription";
  roomEvents: {
    __typename?: "RoomSubscriptionPayload";
    roomName: string;
    adminKickParticipant?: {
      __typename?: "AdminKickParticipantEvent";
      userId: string;
      timestamp: number;
      result?: string | null;
    } | null;
    adminHoldParticipant?: {
      __typename?: "AdminHoldParticipantEvent";
      userId: string;
      timestamp: number;
    } | null;
    adminStatusUpdate?: {
      __typename?: "AdminStatusUpdate";
      status: string;
      timestamp: number;
    } | null;
    adminReapproveParticipant?: {
      __typename?: "AdminReapproveParticipantEvent";
      userId: string;
      timestamp: number;
    } | null;
    adminJoinApprove?: {
      __typename?: "AdminJoinApproveEvent";
      userId: string;
      timestamp: number;
    } | null;
    removeUpcomingUser?: {
      __typename?: "RemoveUpcomingUserEvent";
      userId: string;
      timestamp: number;
    } | null;
    adminAlertParticipant?: {
      __typename?: "AdminAlertParticipantEvent";
      target: string;
      message: string;
      timestamp: number;
    } | null;
  };
};

export type AdminEventsSubscriptionVariables = Exact<{
  roomName: Scalars["String"]["input"];
}>;

export type AdminEventsSubscription = {
  __typename?: "Subscription";
  adminEvents: {
    __typename?: "RoomSubscriptionPayload";
    roomName: string;
    adminKickParticipant?: {
      __typename?: "AdminKickParticipantEvent";
      userId: string;
      timestamp: number;
      result?: string | null;
    } | null;
    adminJoinRequest?: {
      __typename?: "AdminJoinRequestEvent";
      userId: string;
      timestamp: number;
      fullName: string;
    } | null;
    adminHoldParticipant?: {
      __typename?: "AdminHoldParticipantEvent";
      userId: string;
      timestamp: number;
    } | null;
    adminReapproveParticipant?: {
      __typename?: "AdminReapproveParticipantEvent";
      userId: string;
      timestamp: number;
    } | null;
    adminJoinApprove?: {
      __typename?: "AdminJoinApproveEvent";
      userId: string;
      timestamp: number;
    } | null;
    removeUpcomingUser?: {
      __typename?: "RemoveUpcomingUserEvent";
      userId: string;
      timestamp: number;
    } | null;
    adminAlertParticipant?: {
      __typename?: "AdminAlertParticipantEvent";
      target: string;
      message: string;
      timestamp: number;
    } | null;
    adminListUpdate?: {
      __typename?: "AdminListUpdate";
      timestamp: number;
    } | null;
  };
};

export type UserEventsSubscriptionVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type UserEventsSubscription = {
  __typename?: "Subscription";
  userEvents: {
    __typename?: "RoomSubscriptionPayload";
    roomName: string;
    adminKickParticipant?: {
      __typename?: "AdminKickParticipantEvent";
      userId: string;
      timestamp: number;
      result?: string | null;
    } | null;
    adminHoldParticipant?: {
      __typename?: "AdminHoldParticipantEvent";
      userId: string;
      timestamp: number;
    } | null;
    adminReapproveParticipant?: {
      __typename?: "AdminReapproveParticipantEvent";
      userId: string;
      timestamp: number;
    } | null;
    adminJoinApprove?: {
      __typename?: "AdminJoinApproveEvent";
      userId: string;
      timestamp: number;
    } | null;
    removeUpcomingUser?: {
      __typename?: "RemoveUpcomingUserEvent";
      userId: string;
      timestamp: number;
    } | null;
    adminAlertParticipant?: {
      __typename?: "AdminAlertParticipantEvent";
      target: string;
      message: string;
      timestamp: number;
    } | null;
  };
};

export type SetUserStartTimeMutationVariables = Exact<{
  userId: Scalars["String"]["input"];
  startTime: Scalars["String"]["input"];
}>;

export type SetUserStartTimeMutation = {
  __typename?: "Mutation";
  room: { __typename?: "RoomMutations"; setUserStartTime: boolean };
};

export type GetUserStartTimeQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
}>;

export type GetUserStartTimeQuery = {
  __typename?: "Query";
  room: { __typename?: "RoomQueries"; getUserStartTime?: string | null };
};

export type GetUserDurationMinutesQueryVariables = Exact<{
  userId: Scalars["String"]["input"];
  roomName: Scalars["String"]["input"];
}>;

export type GetUserDurationMinutesQuery = {
  __typename?: "Query";
  room: { __typename?: "RoomQueries"; getUserDurationMinutes?: number | null };
};

export const CurrentUserInfoDocument = gql`
  query CurrentUserInfo {
    user {
      currentUserInfo {
        id
        fullName
        avatarUrl
        approved
        visitTime
        wantsToJoin
        role
        hash
        gv_id
        isPaused
        isDone
      }
    }
  }
`;

/**
 * __useCurrentUserInfoQuery__
 *
 * To run a query within a React component, call `useCurrentUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useCurrentUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCurrentUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useCurrentUserInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    CurrentUserInfoQuery,
    CurrentUserInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<CurrentUserInfoQuery, CurrentUserInfoQueryVariables>(
    CurrentUserInfoDocument,
    options
  );
}
export function useCurrentUserInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    CurrentUserInfoQuery,
    CurrentUserInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    CurrentUserInfoQuery,
    CurrentUserInfoQueryVariables
  >(CurrentUserInfoDocument, options);
}
export type CurrentUserInfoQueryHookResult = ReturnType<
  typeof useCurrentUserInfoQuery
>;
export type CurrentUserInfoLazyQueryHookResult = ReturnType<
  typeof useCurrentUserInfoLazyQuery
>;
export type CurrentUserInfoQueryResult = Apollo.QueryResult<
  CurrentUserInfoQuery,
  CurrentUserInfoQueryVariables
>;
export const SendMessageDocument = gql`
  mutation SendMessage($groupId: String!, $text: String!) {
    chat {
      sendMessage(groupId: $groupId, text: $text)
    }
  }
`;
export type SendMessageMutationFn = Apollo.MutationFunction<
  SendMessageMutation,
  SendMessageMutationVariables
>;

/**
 * __useSendMessageMutation__
 *
 * To run a mutation, you first call `useSendMessageMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendMessageMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendMessageMutation, { data, loading, error }] = useSendMessageMutation({
 *   variables: {
 *      groupId: // value for 'groupId'
 *      text: // value for 'text'
 *   },
 * });
 */
export function useSendMessageMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SendMessageMutation,
    SendMessageMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<SendMessageMutation, SendMessageMutationVariables>(
    SendMessageDocument,
    options
  );
}
export type SendMessageMutationHookResult = ReturnType<
  typeof useSendMessageMutation
>;
export type SendMessageMutationResult =
  Apollo.MutationResult<SendMessageMutation>;
export type SendMessageMutationOptions = Apollo.BaseMutationOptions<
  SendMessageMutation,
  SendMessageMutationVariables
>;
export const CreateGroupDocument = gql`
  mutation CreateGroup(
    $id: String!
    $usersId: String!
    $name: String!
    $avatarUrl: String!
  ) {
    chat {
      createGroup(
        id: $id
        name: $name
        usersId: $usersId
        avatarUrl: $avatarUrl
      ) {
        id
        name
        usersIds
        avatarUrl
      }
    }
  }
`;
export type CreateGroupMutationFn = Apollo.MutationFunction<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      id: // value for 'id'
 *      usersId: // value for 'usersId'
 *      name: // value for 'name'
 *      avatarUrl: // value for 'avatarUrl'
 *   },
 * });
 */
export function useCreateGroupMutation(
  baseOptions?: Apollo.MutationHookOptions<
    CreateGroupMutation,
    CreateGroupMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(
    CreateGroupDocument,
    options
  );
}
export type CreateGroupMutationHookResult = ReturnType<
  typeof useCreateGroupMutation
>;
export type CreateGroupMutationResult =
  Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<
  CreateGroupMutation,
  CreateGroupMutationVariables
>;
export const ClearChatDocument = gql`
  mutation clearChat {
    chat {
      clearChat
    }
  }
`;
export type ClearChatMutationFn = Apollo.MutationFunction<
  ClearChatMutation,
  ClearChatMutationVariables
>;

/**
 * __useClearChatMutation__
 *
 * To run a mutation, you first call `useClearChatMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearChatMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearChatMutation, { data, loading, error }] = useClearChatMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearChatMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClearChatMutation,
    ClearChatMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<ClearChatMutation, ClearChatMutationVariables>(
    ClearChatDocument,
    options
  );
}
export type ClearChatMutationHookResult = ReturnType<
  typeof useClearChatMutation
>;
export type ClearChatMutationResult = Apollo.MutationResult<ClearChatMutation>;
export type ClearChatMutationOptions = Apollo.BaseMutationOptions<
  ClearChatMutation,
  ClearChatMutationVariables
>;
export const ChatHistoryDocument = gql`
  query ChatHistory($groupId: String!) {
    chat {
      chatHistory(groupId: $groupId) {
        text
        roomName
        senderId
        senderName
        groupId
        timestamp
      }
    }
  }
`;

/**
 * __useChatHistoryQuery__
 *
 * To run a query within a React component, call `useChatHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useChatHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useChatHistoryQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useChatHistoryQuery(
  baseOptions: Apollo.QueryHookOptions<
    ChatHistoryQuery,
    ChatHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<ChatHistoryQuery, ChatHistoryQueryVariables>(
    ChatHistoryDocument,
    options
  );
}
export function useChatHistoryLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    ChatHistoryQuery,
    ChatHistoryQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<ChatHistoryQuery, ChatHistoryQueryVariables>(
    ChatHistoryDocument,
    options
  );
}
export type ChatHistoryQueryHookResult = ReturnType<typeof useChatHistoryQuery>;
export type ChatHistoryLazyQueryHookResult = ReturnType<
  typeof useChatHistoryLazyQuery
>;
export type ChatHistoryQueryResult = Apollo.QueryResult<
  ChatHistoryQuery,
  ChatHistoryQueryVariables
>;
export const GetGroupByIdDocument = gql`
  query GetGroupById($groupId: String!) {
    chat {
      getGroupById(groupId: $groupId) {
        id
        name
        dateOfCreate
        usersIds
        unreadCount
        avatarUrl
      }
    }
  }
`;

/**
 * __useGetGroupByIdQuery__
 *
 * To run a query within a React component, call `useGetGroupByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupByIdQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupByIdQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetGroupByIdQuery,
    GetGroupByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetGroupByIdQuery, GetGroupByIdQueryVariables>(
    GetGroupByIdDocument,
    options
  );
}
export function useGetGroupByIdLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetGroupByIdQuery,
    GetGroupByIdQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<GetGroupByIdQuery, GetGroupByIdQueryVariables>(
    GetGroupByIdDocument,
    options
  );
}
export type GetGroupByIdQueryHookResult = ReturnType<
  typeof useGetGroupByIdQuery
>;
export type GetGroupByIdLazyQueryHookResult = ReturnType<
  typeof useGetGroupByIdLazyQuery
>;
export type GetGroupByIdQueryResult = Apollo.QueryResult<
  GetGroupByIdQuery,
  GetGroupByIdQueryVariables
>;
export const GetListChatsGroupDocument = gql`
  query GetListChatsGroup {
    chat {
      getListChatsGroup {
        id
        name
        dateOfCreate
        usersIds
        unreadCount
        avatarUrl
      }
    }
  }
`;

/**
 * __useGetListChatsGroupQuery__
 *
 * To run a query within a React component, call `useGetListChatsGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetListChatsGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetListChatsGroupQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetListChatsGroupQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetListChatsGroupQuery,
    GetListChatsGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetListChatsGroupQuery,
    GetListChatsGroupQueryVariables
  >(GetListChatsGroupDocument, options);
}
export function useGetListChatsGroupLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetListChatsGroupQuery,
    GetListChatsGroupQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetListChatsGroupQuery,
    GetListChatsGroupQueryVariables
  >(GetListChatsGroupDocument, options);
}
export type GetListChatsGroupQueryHookResult = ReturnType<
  typeof useGetListChatsGroupQuery
>;
export type GetListChatsGroupLazyQueryHookResult = ReturnType<
  typeof useGetListChatsGroupLazyQuery
>;
export type GetListChatsGroupQueryResult = Apollo.QueryResult<
  GetListChatsGroupQuery,
  GetListChatsGroupQueryVariables
>;
export const ClearEverythingDocument = gql`
  mutation clearEverything {
    chat {
      clearEverything
    }
  }
`;
export type ClearEverythingMutationFn = Apollo.MutationFunction<
  ClearEverythingMutation,
  ClearEverythingMutationVariables
>;

/**
 * __useClearEverythingMutation__
 *
 * To run a mutation, you first call `useClearEverythingMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearEverythingMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearEverythingMutation, { data, loading, error }] = useClearEverythingMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearEverythingMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ClearEverythingMutation,
    ClearEverythingMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ClearEverythingMutation,
    ClearEverythingMutationVariables
  >(ClearEverythingDocument, options);
}
export type ClearEverythingMutationHookResult = ReturnType<
  typeof useClearEverythingMutation
>;
export type ClearEverythingMutationResult =
  Apollo.MutationResult<ClearEverythingMutation>;
export type ClearEverythingMutationOptions = Apollo.BaseMutationOptions<
  ClearEverythingMutation,
  ClearEverythingMutationVariables
>;
export const JoinLivekitDocument = gql`
  mutation JoinLivekit($bioArcRoomId: String!) {
    room {
      join(bioArcRoomId: $bioArcRoomId) {
        success
        livekitToken
        message
        userData {
          avatarUrl
          fullName
          id
          subtitle
          role
        }
        roomData {
          adminId
          name
          startTime
          title
          numMembers
          nameMembers
          adminStatus
        }
      }
    }
  }
`;
export type JoinLivekitMutationFn = Apollo.MutationFunction<
  JoinLivekitMutation,
  JoinLivekitMutationVariables
>;

/**
 * __useJoinLivekitMutation__
 *
 * To run a mutation, you first call `useJoinLivekitMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useJoinLivekitMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [joinLivekitMutation, { data, loading, error }] = useJoinLivekitMutation({
 *   variables: {
 *      bioArcRoomId: // value for 'bioArcRoomId'
 *   },
 * });
 */
export function useJoinLivekitMutation(
  baseOptions?: Apollo.MutationHookOptions<
    JoinLivekitMutation,
    JoinLivekitMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<JoinLivekitMutation, JoinLivekitMutationVariables>(
    JoinLivekitDocument,
    options
  );
}
export type JoinLivekitMutationHookResult = ReturnType<
  typeof useJoinLivekitMutation
>;
export type JoinLivekitMutationResult =
  Apollo.MutationResult<JoinLivekitMutation>;
export type JoinLivekitMutationOptions = Apollo.BaseMutationOptions<
  JoinLivekitMutation,
  JoinLivekitMutationVariables
>;
export const DeleteLivekitRoomDocument = gql`
  mutation DeleteLivekitRoom {
    room {
      deleteLivekitRoom
    }
  }
`;
export type DeleteLivekitRoomMutationFn = Apollo.MutationFunction<
  DeleteLivekitRoomMutation,
  DeleteLivekitRoomMutationVariables
>;

/**
 * __useDeleteLivekitRoomMutation__
 *
 * To run a mutation, you first call `useDeleteLivekitRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteLivekitRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteLivekitRoomMutation, { data, loading, error }] = useDeleteLivekitRoomMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteLivekitRoomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteLivekitRoomMutation,
    DeleteLivekitRoomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeleteLivekitRoomMutation,
    DeleteLivekitRoomMutationVariables
  >(DeleteLivekitRoomDocument, options);
}
export type DeleteLivekitRoomMutationHookResult = ReturnType<
  typeof useDeleteLivekitRoomMutation
>;
export type DeleteLivekitRoomMutationResult =
  Apollo.MutationResult<DeleteLivekitRoomMutation>;
export type DeleteLivekitRoomMutationOptions = Apollo.BaseMutationOptions<
  DeleteLivekitRoomMutation,
  DeleteLivekitRoomMutationVariables
>;
export const KickDocument = gql`
  mutation Kick($identity: String!, $info: info) {
    room {
      kickParticipant(identity: $identity, info: $info)
    }
  }
`;
export type KickMutationFn = Apollo.MutationFunction<
  KickMutation,
  KickMutationVariables
>;

/**
 * __useKickMutation__
 *
 * To run a mutation, you first call `useKickMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useKickMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [kickMutation, { data, loading, error }] = useKickMutation({
 *   variables: {
 *      identity: // value for 'identity'
 *      info: // value for 'info'
 *   },
 * });
 */
export function useKickMutation(
  baseOptions?: Apollo.MutationHookOptions<KickMutation, KickMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<KickMutation, KickMutationVariables>(
    KickDocument,
    options
  );
}
export type KickMutationHookResult = ReturnType<typeof useKickMutation>;
export type KickMutationResult = Apollo.MutationResult<KickMutation>;
export type KickMutationOptions = Apollo.BaseMutationOptions<
  KickMutation,
  KickMutationVariables
>;
export const MuteTrackDocument = gql`
  mutation MuteTrack(
    $roomName: String!
    $identity: String!
    $trackSid: String!
    $muted: Boolean!
  ) {
    room {
      muteTrack(
        roomName: $roomName
        identity: $identity
        trackSid: $trackSid
        muted: $muted
      )
    }
  }
`;
export type MuteTrackMutationFn = Apollo.MutationFunction<
  MuteTrackMutation,
  MuteTrackMutationVariables
>;

/**
 * __useMuteTrackMutation__
 *
 * To run a mutation, you first call `useMuteTrackMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMuteTrackMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [muteTrackMutation, { data, loading, error }] = useMuteTrackMutation({
 *   variables: {
 *      roomName: // value for 'roomName'
 *      identity: // value for 'identity'
 *      trackSid: // value for 'trackSid'
 *      muted: // value for 'muted'
 *   },
 * });
 */
export function useMuteTrackMutation(
  baseOptions?: Apollo.MutationHookOptions<
    MuteTrackMutation,
    MuteTrackMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<MuteTrackMutation, MuteTrackMutationVariables>(
    MuteTrackDocument,
    options
  );
}
export type MuteTrackMutationHookResult = ReturnType<
  typeof useMuteTrackMutation
>;
export type MuteTrackMutationResult = Apollo.MutationResult<MuteTrackMutation>;
export type MuteTrackMutationOptions = Apollo.BaseMutationOptions<
  MuteTrackMutation,
  MuteTrackMutationVariables
>;
export const DeleteRoomDocument = gql`
  mutation DeleteRoom {
    room {
      deleteLivekitRoom
    }
  }
`;
export type DeleteRoomMutationFn = Apollo.MutationFunction<
  DeleteRoomMutation,
  DeleteRoomMutationVariables
>;

/**
 * __useDeleteRoomMutation__
 *
 * To run a mutation, you first call `useDeleteRoomMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteRoomMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteRoomMutation, { data, loading, error }] = useDeleteRoomMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeleteRoomMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeleteRoomMutation,
    DeleteRoomMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<DeleteRoomMutation, DeleteRoomMutationVariables>(
    DeleteRoomDocument,
    options
  );
}
export type DeleteRoomMutationHookResult = ReturnType<
  typeof useDeleteRoomMutation
>;
export type DeleteRoomMutationResult =
  Apollo.MutationResult<DeleteRoomMutation>;
export type DeleteRoomMutationOptions = Apollo.BaseMutationOptions<
  DeleteRoomMutation,
  DeleteRoomMutationVariables
>;
export const GetUpcomingUsersDocument = gql`
  query GetUpcomingUsers($roomName: String!) {
    room {
      upcomingUsers(roomName: $roomName) {
        id
        fullName
        avatarUrl
        approved
        visitTime
        wantsToJoin
        role
        hash
        gv_id
        start_local
        end_local
        visit_guest
        isPaused
        isDone
        duration_minutes
      }
    }
  }
`;

/**
 * __useGetUpcomingUsersQuery__
 *
 * To run a query within a React component, call `useGetUpcomingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUpcomingUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUpcomingUsersQuery({
 *   variables: {
 *      roomName: // value for 'roomName'
 *   },
 * });
 */
export function useGetUpcomingUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUpcomingUsersQuery,
    GetUpcomingUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUpcomingUsersQuery, GetUpcomingUsersQueryVariables>(
    GetUpcomingUsersDocument,
    options
  );
}
export function useGetUpcomingUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUpcomingUsersQuery,
    GetUpcomingUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUpcomingUsersQuery,
    GetUpcomingUsersQueryVariables
  >(GetUpcomingUsersDocument, options);
}
export type GetUpcomingUsersQueryHookResult = ReturnType<
  typeof useGetUpcomingUsersQuery
>;
export type GetUpcomingUsersLazyQueryHookResult = ReturnType<
  typeof useGetUpcomingUsersLazyQuery
>;
export type GetUpcomingUsersQueryResult = Apollo.QueryResult<
  GetUpcomingUsersQuery,
  GetUpcomingUsersQueryVariables
>;
export const GetLatestUpcomingUsersDocument = gql`
  query GetLatestUpcomingUsers {
    room {
      getLatestUpcomingUsers {
        id
        fullName
        avatarUrl
        approved
        visitTime
        wantsToJoin
        role
        hash
        gv_id
        start_local
        end_local
        visit_guest
        isPaused
        isDone
        duration_minutes
      }
    }
  }
`;

/**
 * __useGetLatestUpcomingUsersQuery__
 *
 * To run a query within a React component, call `useGetLatestUpcomingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestUpcomingUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestUpcomingUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLatestUpcomingUsersQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetLatestUpcomingUsersQuery,
    GetLatestUpcomingUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetLatestUpcomingUsersQuery,
    GetLatestUpcomingUsersQueryVariables
  >(GetLatestUpcomingUsersDocument, options);
}
export function useGetLatestUpcomingUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetLatestUpcomingUsersQuery,
    GetLatestUpcomingUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetLatestUpcomingUsersQuery,
    GetLatestUpcomingUsersQueryVariables
  >(GetLatestUpcomingUsersDocument, options);
}
export type GetLatestUpcomingUsersQueryHookResult = ReturnType<
  typeof useGetLatestUpcomingUsersQuery
>;
export type GetLatestUpcomingUsersLazyQueryHookResult = ReturnType<
  typeof useGetLatestUpcomingUsersLazyQuery
>;
export type GetLatestUpcomingUsersQueryResult = Apollo.QueryResult<
  GetLatestUpcomingUsersQuery,
  GetLatestUpcomingUsersQueryVariables
>;
export const GetWaitingUsersDocument = gql`
  query GetWaitingUsers($roomName: String!) {
    room {
      waitingUsers(roomName: $roomName) {
        id
        fullName
        avatarUrl
        approved
        visitTime
        wantsToJoin
        role
        hash
        gv_id
        start_local
        end_local
        visit_guest
        isPaused
        isDone
        duration_minutes
      }
    }
  }
`;

/**
 * __useGetWaitingUsersQuery__
 *
 * To run a query within a React component, call `useGetWaitingUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWaitingUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWaitingUsersQuery({
 *   variables: {
 *      roomName: // value for 'roomName'
 *   },
 * });
 */
export function useGetWaitingUsersQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetWaitingUsersQuery,
    GetWaitingUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetWaitingUsersQuery, GetWaitingUsersQueryVariables>(
    GetWaitingUsersDocument,
    options
  );
}
export function useGetWaitingUsersLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetWaitingUsersQuery,
    GetWaitingUsersQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetWaitingUsersQuery,
    GetWaitingUsersQueryVariables
  >(GetWaitingUsersDocument, options);
}
export type GetWaitingUsersQueryHookResult = ReturnType<
  typeof useGetWaitingUsersQuery
>;
export type GetWaitingUsersLazyQueryHookResult = ReturnType<
  typeof useGetWaitingUsersLazyQuery
>;
export type GetWaitingUsersQueryResult = Apollo.QueryResult<
  GetWaitingUsersQuery,
  GetWaitingUsersQueryVariables
>;
export const GetRoomLineInfoDocument = gql`
  query GetRoomLineInfo {
    room {
      lineinfo {
        count
        index
        DocStatus
        found_user {
          id
          fullName
          avatarUrl
          visitTime
          approved
          wantsToJoin
        }
      }
    }
  }
`;

/**
 * __useGetRoomLineInfoQuery__
 *
 * To run a query within a React component, call `useGetRoomLineInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRoomLineInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRoomLineInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRoomLineInfoQuery(
  baseOptions?: Apollo.QueryHookOptions<
    GetRoomLineInfoQuery,
    GetRoomLineInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetRoomLineInfoQuery, GetRoomLineInfoQueryVariables>(
    GetRoomLineInfoDocument,
    options
  );
}
export function useGetRoomLineInfoLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetRoomLineInfoQuery,
    GetRoomLineInfoQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetRoomLineInfoQuery,
    GetRoomLineInfoQueryVariables
  >(GetRoomLineInfoDocument, options);
}
export type GetRoomLineInfoQueryHookResult = ReturnType<
  typeof useGetRoomLineInfoQuery
>;
export type GetRoomLineInfoLazyQueryHookResult = ReturnType<
  typeof useGetRoomLineInfoLazyQuery
>;
export type GetRoomLineInfoQueryResult = Apollo.QueryResult<
  GetRoomLineInfoQuery,
  GetRoomLineInfoQueryVariables
>;
export const GetPatientDocumentDocument = gql`
  query GetPatientDocument($vid: String!) {
    room {
      getPatientDocument(vid: $vid) {
        id
        pid
        vid
        filename
        location
        gv_docs_data_id
        sender_id
        desc
        date
      }
    }
  }
`;

/**
 * __useGetPatientDocumentQuery__
 *
 * To run a query within a React component, call `useGetPatientDocumentQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPatientDocumentQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPatientDocumentQuery({
 *   variables: {
 *      vid: // value for 'vid'
 *   },
 * });
 */
export function useGetPatientDocumentQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetPatientDocumentQuery,
    GetPatientDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetPatientDocumentQuery,
    GetPatientDocumentQueryVariables
  >(GetPatientDocumentDocument, options);
}
export function useGetPatientDocumentLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetPatientDocumentQuery,
    GetPatientDocumentQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetPatientDocumentQuery,
    GetPatientDocumentQueryVariables
  >(GetPatientDocumentDocument, options);
}
export type GetPatientDocumentQueryHookResult = ReturnType<
  typeof useGetPatientDocumentQuery
>;
export type GetPatientDocumentLazyQueryHookResult = ReturnType<
  typeof useGetPatientDocumentLazyQuery
>;
export type GetPatientDocumentQueryResult = Apollo.QueryResult<
  GetPatientDocumentQuery,
  GetPatientDocumentQueryVariables
>;
export const ApproveUpcomingUserDocument = gql`
  mutation ApproveUpcomingUser($userId: String!) {
    room {
      approveUpcomingUser(userId: $userId)
    }
  }
`;
export type ApproveUpcomingUserMutationFn = Apollo.MutationFunction<
  ApproveUpcomingUserMutation,
  ApproveUpcomingUserMutationVariables
>;

/**
 * __useApproveUpcomingUserMutation__
 *
 * To run a mutation, you first call `useApproveUpcomingUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useApproveUpcomingUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [approveUpcomingUserMutation, { data, loading, error }] = useApproveUpcomingUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useApproveUpcomingUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    ApproveUpcomingUserMutation,
    ApproveUpcomingUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    ApproveUpcomingUserMutation,
    ApproveUpcomingUserMutationVariables
  >(ApproveUpcomingUserDocument, options);
}
export type ApproveUpcomingUserMutationHookResult = ReturnType<
  typeof useApproveUpcomingUserMutation
>;
export type ApproveUpcomingUserMutationResult =
  Apollo.MutationResult<ApproveUpcomingUserMutation>;
export type ApproveUpcomingUserMutationOptions = Apollo.BaseMutationOptions<
  ApproveUpcomingUserMutation,
  ApproveUpcomingUserMutationVariables
>;
export const AskToJionDocument = gql`
  mutation AskToJion {
    room {
      askToJion
    }
  }
`;
export type AskToJionMutationFn = Apollo.MutationFunction<
  AskToJionMutation,
  AskToJionMutationVariables
>;

/**
 * __useAskToJionMutation__
 *
 * To run a mutation, you first call `useAskToJionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAskToJionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [askToJionMutation, { data, loading, error }] = useAskToJionMutation({
 *   variables: {
 *   },
 * });
 */
export function useAskToJionMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AskToJionMutation,
    AskToJionMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AskToJionMutation, AskToJionMutationVariables>(
    AskToJionDocument,
    options
  );
}
export type AskToJionMutationHookResult = ReturnType<
  typeof useAskToJionMutation
>;
export type AskToJionMutationResult = Apollo.MutationResult<AskToJionMutation>;
export type AskToJionMutationOptions = Apollo.BaseMutationOptions<
  AskToJionMutation,
  AskToJionMutationVariables
>;
export const AlertTheParticipantDocument = gql`
  mutation AlertTheParticipant($target: String!, $message: String!) {
    room {
      alertTheParticipant(target: $target, message: $message)
    }
  }
`;
export type AlertTheParticipantMutationFn = Apollo.MutationFunction<
  AlertTheParticipantMutation,
  AlertTheParticipantMutationVariables
>;

/**
 * __useAlertTheParticipantMutation__
 *
 * To run a mutation, you first call `useAlertTheParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAlertTheParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [alertTheParticipantMutation, { data, loading, error }] = useAlertTheParticipantMutation({
 *   variables: {
 *      target: // value for 'target'
 *      message: // value for 'message'
 *   },
 * });
 */
export function useAlertTheParticipantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AlertTheParticipantMutation,
    AlertTheParticipantMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    AlertTheParticipantMutation,
    AlertTheParticipantMutationVariables
  >(AlertTheParticipantDocument, options);
}
export type AlertTheParticipantMutationHookResult = ReturnType<
  typeof useAlertTheParticipantMutation
>;
export type AlertTheParticipantMutationResult =
  Apollo.MutationResult<AlertTheParticipantMutation>;
export type AlertTheParticipantMutationOptions = Apollo.BaseMutationOptions<
  AlertTheParticipantMutation,
  AlertTheParticipantMutationVariables
>;
export const RemoveUpcomingUserDocument = gql`
  mutation RemoveUpcomingUser($userId: String!) {
    room {
      removeUpcomingUser(userId: $userId)
    }
  }
`;
export type RemoveUpcomingUserMutationFn = Apollo.MutationFunction<
  RemoveUpcomingUserMutation,
  RemoveUpcomingUserMutationVariables
>;

/**
 * __useRemoveUpcomingUserMutation__
 *
 * To run a mutation, you first call `useRemoveUpcomingUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveUpcomingUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeUpcomingUserMutation, { data, loading, error }] = useRemoveUpcomingUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useRemoveUpcomingUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    RemoveUpcomingUserMutation,
    RemoveUpcomingUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    RemoveUpcomingUserMutation,
    RemoveUpcomingUserMutationVariables
  >(RemoveUpcomingUserDocument, options);
}
export type RemoveUpcomingUserMutationHookResult = ReturnType<
  typeof useRemoveUpcomingUserMutation
>;
export type RemoveUpcomingUserMutationResult =
  Apollo.MutationResult<RemoveUpcomingUserMutation>;
export type RemoveUpcomingUserMutationOptions = Apollo.BaseMutationOptions<
  RemoveUpcomingUserMutation,
  RemoveUpcomingUserMutationVariables
>;
export const HoldParticipantDocument = gql`
  mutation holdParticipant($identity: String!, $isTakeBack: Boolean) {
    room {
      holdParticipant(identity: $identity, isTakeBack: $isTakeBack)
    }
  }
`;
export type HoldParticipantMutationFn = Apollo.MutationFunction<
  HoldParticipantMutation,
  HoldParticipantMutationVariables
>;

/**
 * __useHoldParticipantMutation__
 *
 * To run a mutation, you first call `useHoldParticipantMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHoldParticipantMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [holdParticipantMutation, { data, loading, error }] = useHoldParticipantMutation({
 *   variables: {
 *      identity: // value for 'identity'
 *      isTakeBack: // value for 'isTakeBack'
 *   },
 * });
 */
export function useHoldParticipantMutation(
  baseOptions?: Apollo.MutationHookOptions<
    HoldParticipantMutation,
    HoldParticipantMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    HoldParticipantMutation,
    HoldParticipantMutationVariables
  >(HoldParticipantDocument, options);
}
export type HoldParticipantMutationHookResult = ReturnType<
  typeof useHoldParticipantMutation
>;
export type HoldParticipantMutationResult =
  Apollo.MutationResult<HoldParticipantMutation>;
export type HoldParticipantMutationOptions = Apollo.BaseMutationOptions<
  HoldParticipantMutation,
  HoldParticipantMutationVariables
>;
export const UpdateUpcomingVisitTimesDocument = gql`
  mutation UpdateUpcomingVisitTimes($updates: [VisitTimeUpdateInput!]!) {
    room {
      updateUpcomingVisitTimes(updates: $updates) {
        id
        fullName
        visitTime
        approved
        wantsToJoin
        role
        visit_guest
        avatarUrl
      }
    }
  }
`;
export type UpdateUpcomingVisitTimesMutationFn = Apollo.MutationFunction<
  UpdateUpcomingVisitTimesMutation,
  UpdateUpcomingVisitTimesMutationVariables
>;

/**
 * __useUpdateUpcomingVisitTimesMutation__
 *
 * To run a mutation, you first call `useUpdateUpcomingVisitTimesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateUpcomingVisitTimesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateUpcomingVisitTimesMutation, { data, loading, error }] = useUpdateUpcomingVisitTimesMutation({
 *   variables: {
 *      updates: // value for 'updates'
 *   },
 * });
 */
export function useUpdateUpcomingVisitTimesMutation(
  baseOptions?: Apollo.MutationHookOptions<
    UpdateUpcomingVisitTimesMutation,
    UpdateUpcomingVisitTimesMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    UpdateUpcomingVisitTimesMutation,
    UpdateUpcomingVisitTimesMutationVariables
  >(UpdateUpcomingVisitTimesDocument, options);
}
export type UpdateUpcomingVisitTimesMutationHookResult = ReturnType<
  typeof useUpdateUpcomingVisitTimesMutation
>;
export type UpdateUpcomingVisitTimesMutationResult =
  Apollo.MutationResult<UpdateUpcomingVisitTimesMutation>;
export type UpdateUpcomingVisitTimesMutationOptions =
  Apollo.BaseMutationOptions<
    UpdateUpcomingVisitTimesMutation,
    UpdateUpcomingVisitTimesMutationVariables
  >;
export const AdmitUserDocument = gql`
  mutation admitUser($target: String!) {
    room {
      admitUser(target: $target) {
        id
        fullName
        avatarUrl
        approved
        visitTime
        wantsToJoin
        role
        hash
        gv_id
        start_local
        end_local
        visit_guest
        isPaused
        isDone
        duration_minutes
      }
    }
  }
`;
export type AdmitUserMutationFn = Apollo.MutationFunction<
  AdmitUserMutation,
  AdmitUserMutationVariables
>;

/**
 * __useAdmitUserMutation__
 *
 * To run a mutation, you first call `useAdmitUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdmitUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [admitUserMutation, { data, loading, error }] = useAdmitUserMutation({
 *   variables: {
 *      target: // value for 'target'
 *   },
 * });
 */
export function useAdmitUserMutation(
  baseOptions?: Apollo.MutationHookOptions<
    AdmitUserMutation,
    AdmitUserMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<AdmitUserMutation, AdmitUserMutationVariables>(
    AdmitUserDocument,
    options
  );
}
export type AdmitUserMutationHookResult = ReturnType<
  typeof useAdmitUserMutation
>;
export type AdmitUserMutationResult = Apollo.MutationResult<AdmitUserMutation>;
export type AdmitUserMutationOptions = Apollo.BaseMutationOptions<
  AdmitUserMutation,
  AdmitUserMutationVariables
>;
export const RoomEventsDocument = gql`
  subscription RoomEvents($roomName: String!) {
    roomEvents(roomName: $roomName) {
      roomName
      adminKickParticipant {
        userId
        timestamp
        result
      }
      adminHoldParticipant {
        userId
        timestamp
      }
      adminStatusUpdate {
        status
        timestamp
      }
      adminReapproveParticipant {
        userId
        timestamp
      }
      adminJoinApprove {
        userId
        timestamp
      }
      removeUpcomingUser {
        userId
        timestamp
      }
      adminAlertParticipant {
        target
        message
        timestamp
      }
    }
  }
`;

/**
 * __useRoomEventsSubscription__
 *
 * To run a query within a React component, call `useRoomEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useRoomEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRoomEventsSubscription({
 *   variables: {
 *      roomName: // value for 'roomName'
 *   },
 * });
 */
export function useRoomEventsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    RoomEventsSubscription,
    RoomEventsSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    RoomEventsSubscription,
    RoomEventsSubscriptionVariables
  >(RoomEventsDocument, options);
}
export type RoomEventsSubscriptionHookResult = ReturnType<
  typeof useRoomEventsSubscription
>;
export type RoomEventsSubscriptionResult =
  Apollo.SubscriptionResult<RoomEventsSubscription>;
export const AdminEventsDocument = gql`
  subscription AdminEvents($roomName: String!) {
    adminEvents(roomName: $roomName) {
      roomName
      adminKickParticipant {
        userId
        timestamp
        result
      }
      adminJoinRequest {
        userId
        timestamp
        fullName
      }
      adminHoldParticipant {
        userId
        timestamp
      }
      adminReapproveParticipant {
        userId
        timestamp
      }
      adminJoinApprove {
        userId
        timestamp
      }
      removeUpcomingUser {
        userId
        timestamp
      }
      adminAlertParticipant {
        target
        message
        timestamp
      }
      adminListUpdate {
        timestamp
      }
    }
  }
`;

/**
 * __useAdminEventsSubscription__
 *
 * To run a query within a React component, call `useAdminEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useAdminEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAdminEventsSubscription({
 *   variables: {
 *      roomName: // value for 'roomName'
 *   },
 * });
 */
export function useAdminEventsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    AdminEventsSubscription,
    AdminEventsSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    AdminEventsSubscription,
    AdminEventsSubscriptionVariables
  >(AdminEventsDocument, options);
}
export type AdminEventsSubscriptionHookResult = ReturnType<
  typeof useAdminEventsSubscription
>;
export type AdminEventsSubscriptionResult =
  Apollo.SubscriptionResult<AdminEventsSubscription>;
export const UserEventsDocument = gql`
  subscription UserEvents($userId: String!) {
    userEvents(userId: $userId) {
      roomName
      adminKickParticipant {
        userId
        timestamp
        result
      }
      adminHoldParticipant {
        userId
        timestamp
      }
      adminReapproveParticipant {
        userId
        timestamp
      }
      adminJoinApprove {
        userId
        timestamp
      }
      removeUpcomingUser {
        userId
        timestamp
      }
      adminAlertParticipant {
        target
        message
        timestamp
      }
    }
  }
`;

/**
 * __useUserEventsSubscription__
 *
 * To run a query within a React component, call `useUserEventsSubscription` and pass it any options that fit your needs.
 * When your component renders, `useUserEventsSubscription` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the subscription, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUserEventsSubscription({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useUserEventsSubscription(
  baseOptions: Apollo.SubscriptionHookOptions<
    UserEventsSubscription,
    UserEventsSubscriptionVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useSubscription<
    UserEventsSubscription,
    UserEventsSubscriptionVariables
  >(UserEventsDocument, options);
}
export type UserEventsSubscriptionHookResult = ReturnType<
  typeof useUserEventsSubscription
>;
export type UserEventsSubscriptionResult =
  Apollo.SubscriptionResult<UserEventsSubscription>;
export const SetUserStartTimeDocument = gql`
  mutation SetUserStartTime($userId: String!, $startTime: String!) {
    room {
      setUserStartTime(userId: $userId, startTime: $startTime)
    }
  }
`;
export type SetUserStartTimeMutationFn = Apollo.MutationFunction<
  SetUserStartTimeMutation,
  SetUserStartTimeMutationVariables
>;

/**
 * __useSetUserStartTimeMutation__
 *
 * To run a mutation, you first call `useSetUserStartTimeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSetUserStartTimeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [setUserStartTimeMutation, { data, loading, error }] = useSetUserStartTimeMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *      startTime: // value for 'startTime'
 *   },
 * });
 */
export function useSetUserStartTimeMutation(
  baseOptions?: Apollo.MutationHookOptions<
    SetUserStartTimeMutation,
    SetUserStartTimeMutationVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    SetUserStartTimeMutation,
    SetUserStartTimeMutationVariables
  >(SetUserStartTimeDocument, options);
}
export type SetUserStartTimeMutationHookResult = ReturnType<
  typeof useSetUserStartTimeMutation
>;
export type SetUserStartTimeMutationResult =
  Apollo.MutationResult<SetUserStartTimeMutation>;
export type SetUserStartTimeMutationOptions = Apollo.BaseMutationOptions<
  SetUserStartTimeMutation,
  SetUserStartTimeMutationVariables
>;
export const GetUserStartTimeDocument = gql`
  query GetUserStartTime($userId: String!) {
    room {
      getUserStartTime(userId: $userId)
    }
  }
`;

/**
 * __useGetUserStartTimeQuery__
 *
 * To run a query within a React component, call `useGetUserStartTimeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserStartTimeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserStartTimeQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useGetUserStartTimeQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserStartTimeQuery,
    GetUserStartTimeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetUserStartTimeQuery, GetUserStartTimeQueryVariables>(
    GetUserStartTimeDocument,
    options
  );
}
export function useGetUserStartTimeLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserStartTimeQuery,
    GetUserStartTimeQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserStartTimeQuery,
    GetUserStartTimeQueryVariables
  >(GetUserStartTimeDocument, options);
}
export type GetUserStartTimeQueryHookResult = ReturnType<
  typeof useGetUserStartTimeQuery
>;
export type GetUserStartTimeLazyQueryHookResult = ReturnType<
  typeof useGetUserStartTimeLazyQuery
>;
export type GetUserStartTimeQueryResult = Apollo.QueryResult<
  GetUserStartTimeQuery,
  GetUserStartTimeQueryVariables
>;
export const GetUserDurationMinutesDocument = gql`
  query GetUserDurationMinutes($userId: String!, $roomName: String!) {
    room {
      getUserDurationMinutes(userId: $userId, roomName: $roomName)
    }
  }
`;

/**
 * __useGetUserDurationMinutesQuery__
 *
 * To run a query within a React component, call `useGetUserDurationMinutesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserDurationMinutesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserDurationMinutesQuery({
 *   variables: {
 *      userId: // value for 'userId'
 *      roomName: // value for 'roomName'
 *   },
 * });
 */
export function useGetUserDurationMinutesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetUserDurationMinutesQuery,
    GetUserDurationMinutesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetUserDurationMinutesQuery,
    GetUserDurationMinutesQueryVariables
  >(GetUserDurationMinutesDocument, options);
}
export function useGetUserDurationMinutesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetUserDurationMinutesQuery,
    GetUserDurationMinutesQueryVariables
  >
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetUserDurationMinutesQuery,
    GetUserDurationMinutesQueryVariables
  >(GetUserDurationMinutesDocument, options);
}
export type GetUserDurationMinutesQueryHookResult = ReturnType<
  typeof useGetUserDurationMinutesQuery
>;
export type GetUserDurationMinutesLazyQueryHookResult = ReturnType<
  typeof useGetUserDurationMinutesLazyQuery
>;
export type GetUserDurationMinutesQueryResult = Apollo.QueryResult<
  GetUserDurationMinutesQuery,
  GetUserDurationMinutesQueryVariables
>;
